<script setup lang="ts">
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
</script>

<template>
	<Suspense>
		<template #default>
			<RouterView />
		</template>
		<template #fallback>
			<div class="global-loader">
				<div class="spinner-large"></div>
			</div>
		</template>
	</Suspense>
</template>

<style>
*,
*::before,
*::after {
	box-sizing: border-box;
	margin: 0;
	padding: 0;
}

html,
body {
	height: 100%;
	font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

.global-loader {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100vh;
}

.spinner-large {
	width: 40px;
	height: 40px;
	border: 3px solid #e2e8f0;
	border-top-color: #667eea;
	border-radius: 50%;
	animation: spin 0.6s linear infinite;
}

@keyframes spin {
	to {
		transform: rotate(360deg);
	}
}
</style>
